<template>
  <VFlex>
    <VTextField
      :label="$nt('label')"
      :error-messages="emailError"
      :value="value"
      :rules="[$rules.isRequired, $rules.isValidEmail]"
      @input="email => $emit('input', email)"
    />
  </VFlex>
</template>

<script>
export default {
  name: 'EmailInput',
  props: {
    emailError: {
      type: Array,
      default: () => {}
    },
    value: {
      type: String,
      default: ''
    }
  }
}
</script>
